/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { LoginResultCompanyViewModel } from "../types/LoginResultCompanyViewModel.ts";

export const loginResultCompanyViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da empresa.")),
  code: z.string().describe("Código identificador da empresa.").nullish(),
  name: z.string().describe("Nome da empresa.").nullish(),
  profile: z.optional(
    z
      .number()
      .int()
      .describe(
        "Perfil de acesso do usuário nesta empresa. Enum EUserRole: `1` = Master, `2` = Administrator, `3` = Polo, `4` = Basic, `5` = Relationship, `6` = Planning, `7` = Secretary, `8` = Communication, `9` = Financial, `10` = Visitor, `11` = API, `12` = StudentCare, `13` = Valoriza, `14` = Leads, `15` = Faculty, `16` = Orientation, `17` = Exams, `18` = BusinessCore, `19` = Contracts, `20` = HumanResources, `21` = Audiovisual, `22` = ScholarshipTeam, `23` = Translation, `24` = Transmission, `25` = RelationshipTR, `26` = International.",
      ),
  ),
}) as unknown as ToZod<LoginResultCompanyViewModel>;
